export default "assets/images/logo-af5d1994.png";